module.exports = __webpack_public_path__ + "img/ac3fb85f155217786ae2f56eed3ac7d4.png";